(function () {
    'use strict';

    angular
        .module('app.influencerManagementLogDetailed', [])
        .controller('influencerManagementLogDetailedCtrl', ['$scope', '$rootScope', 'influencerManagementLogDetailedService', '$modal', '$modalInstance',
            function ($scope, $rootScope, influencerManagementLogDetailedService, $modal, $modalInstance) {
                
                $scope.closeModal = function() {
                	$modalInstance.dismiss();
                }

                $scope.getInfluencerManagementLogDetailed = function(influencer_mangement_log_id) {
                	influencerManagementLogDetailedService.getInfluencerManagementLogDetailed(influencer_mangement_log_id, true)
                		.then(function(response) {
                			$scope.influencerManagementLogDetailed = response.data;
                		})
                }

                $scope.getInfluencerManagementLogDetailed($scope.influencer_management_log_id);

                $scope.influencerDetails = function () {
                    var influencerDetailsModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/influencers_influencer_details.html?app_v=deployDate',
                        controller: 'InfluencerDetailsCtrl'
                    });

                    $scope.influencerDetailsModalInstance = influencerDetailsModalInstance;
                    $scope.id = $scope.influencer_id;
                    $scope.flag = true;
                    $scope.fromInfluencerLog = true;
                };
            }
        ])
})();